export const TUTORIAL_STEPS = 'questionList-tutorial-state';

// load tutorial steps from local storage
export const load = () => {
  try {
    const serializedState = localStorage.getItem(TUTORIAL_STEPS);
    if (serializedState === null) {
      return undefined;
    }

    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const save = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem(TUTORIAL_STEPS, serializedState);
  } catch (err) {
    console.log(err);
  }
};



// WEBPACK FOOTER //
// ./src/utils/localQuestionListTutorial.js